export enum UserRoles {
  Admin = 'ADMIN',
  ClubAdmin = 'clubAdmin',
  DuprAdmin = 'duprAdmin',
  ClubEmployee = 'CLUB_Employee',
}

export const UserRoleNames = {
  [UserRoles.Admin]: 'Swish Admin',
  [UserRoles.ClubAdmin]: 'Club Admin',
  [UserRoles.DuprAdmin]: 'DUPR Admin',
  [UserRoles.ClubEmployee]: 'Club Employee',
};

export enum UserFields {
  Uid = 'uid',
  Fid = 'fid',
  Username = 'username',
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  ProfilePicture = 'profilePicture',
  FavSports = 'favSports',
  FcmToken = 'fcmToken',
  TimeZone = 'timeZone',
  Index = 'index',
  BlockedBy = 'blockedBy',
  DuprSession = 'duprSession',
  DuprClubId = 'duprClubId',
  PhoneNumber = 'phoneNumber',
  SmsNumber = 'smsNumber',
  Roles = 'roles',
  Gender = 'gender',
  Clubs = 'clubs',
  Groups = 'groups',
  Games = 'games',
  HomeCity = 'homeCity',
  EmployeeUids = 'employeeUids',
  EmployerUids = 'employerUids',
  ClubAdminUids = 'clubAdminUids',
  Status = 'status',
  UpdatedAt = 'updatedAt',
}

export const UserLabels = {
  [UserFields.Uid]: 'UID',
  [UserFields.Fid]: 'FID',
  [UserFields.Username]: 'Username',
  [UserFields.ProfilePicture]: 'Profile Picture',
  [UserFields.FavSports]: 'Sports',
  [UserFields.DuprSession]: 'duprSession',
  [UserFields.DuprClubId]: 'duprClubId',
  [UserFields.SmsNumber]: 'smsNumber',
  [UserFields.Roles]: 'roles',
  [UserFields.Gender]: 'gender',
  [UserFields.Clubs]: 'clubs',
  [UserFields.Groups]: 'groups',
  [UserFields.Games]: 'games',
  [UserFields.HomeCity]: 'homeCity',
  [UserFields.EmployeeUids]: 'employeeUids',
  [UserFields.EmployerUids]: 'employerUids',
  [UserFields.Status]: 'status',
  [UserFields.UpdatedAt]: 'Updated',
};

export enum UserGameTypes {
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export enum UserLocationTypes {
  Country = 'country',
  City = 'city',
  State = 'state',
  Location = 'location',
}
